import { useState } from "react";
import logo from "../assets/logo.png"
import NavItem from "./NavItem";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="w-full shadow-sm">
      <div className="max-w-7xl mx-auto px-5 py-4 flex justify-between items-center">

        {/* Logo */}
        <div>
          <img
            src={logo}
            alt="msmLogo"
            className="w-40 h-20 object-contain"
          />
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex gap-8 text-base font-medium">
          <NavItem to="/" label="Home" />
          <NavItem to="/AboutUs" label="About Us" />
          <NavItem to="/CoursesSection" label="Courses" />
          <NavItem to="/business" label="For Business" />
          <NavItem to="/training" label="Training" />
          <NavItem to="/contact" label="Contact" />
        </ul>


        {/* Mobile Menu Button */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-2xl"
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <ul className="md:hidden bg-white border-t py-5 px-6 space-y-4 text-lg">
          <NavItem to="/" label="Home" />
          <NavItem to="/AboutUs" label="About Us" />
          <NavItem to="/CoursesSection" label="Courses" />
          <NavItem to="/business" label="For Business" />
          <NavItem to="/training" label="Training" />
          <NavItem to="/contact" label="Contact" />
        </ul>
      )}
    </nav>
  );
}
